import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../services/app.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PageNotFoundComponent {
  calculationAccess$: Observable<boolean>
  calculationInTrash$: Observable<boolean>

  constructor(private _appService: AppService) { 
    this.calculationAccess$ = _appService.calculationAccess$;
      this.calculationInTrash$ = _appService.calculationInTrash$;
  }

}
